module.exports = __webpack_public_path__ + "img/logo.7b00d341.png";